export const FINANCIAL_TEMPLATES = "v1/financial-templates";
